import React from 'react';


class Subscribe extends React.Component {
   render() {

      return (
         <section>
            <div className="container">
               <div className="row">
                  <div className="col-md-8 offset-md-2">
                     <div className="footer-text">
                        <img src="assets/images/email.png" alt="email" />
                        <h2 className="title text-center md-margin-top">ΕΓΓΡΑΦΗ ΣΤΟ <span>newsletter</span></h2>
                        <p>  Μάθετε πρώτοι όλες τις επερχόμενες εκθέσεις και τα νέα μας.</p>
                        <form action="https://qrstand.us20.list-manage.com/subscribe/post" className="footer-form needs-validation" method="post" target="_blank">
                           <input type="hidden" name="u" value="9a3c4e57d94e658b61d721f93" />
                           <input type="hidden" name="id" value="d30096aff3" />
                           <div className="form-group">
                              <input type="email" className="form-control" placeholder="Το e-mail σας" name="MERGE0" id="MERGE0" required="required" />
                           </div>
                           <div className="form-button">
                              <button type="submit" className="btn btn-custom theme-color" id="mc-submit">ΕΓΓΡΑΦΗ</button>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}


export default Subscribe;


// WEBPACK FOOTER //
// ./src/components/subscribe.js